// extracted by mini-css-extract-plugin
export default {"PlayButton":"PlayButton_PlayButton__pOA1D","PlayerControls-icon":"PlayButton_PlayerControls-icon__ml5OX"};